
<div mat-dialog-content [mat-dialog-close]="true">

	<!--<div style="height:200px">
		<lottie-anim [options]="{animation: 'check', autoplay: true, loop: false, speed:1 }" [height]="200"></lottie-anim>
	</div>-->

	<img src="/assets/images/pay-success-check.png" style="margin-bottom: 25px"/>

	<div style="padding: 0 25px; margin-bottom: 20px;">
		<div class="_title">{{'MESSAGES.PAYMENT_ACCEPTED_SUCCESSFULLY' | translate}}</div>
		<div class="_title-info">{{'server_knows' | translate}}</div>
	</div>

	<div class="_payment text-accent">
		<div class="_amount">{{data.amount}}</div>
		<div class="_gratuity" *ngIf="data.gratuity?.amount">
			(<span class="inline mr-2">{{data.gratuity.amount | lcurrency:'1.2-2'}}</span><span>{{'gratuity' | translate}}</span>)
		</div>
		<div class="_info" *ngIf="data.ccinfo.caption">{{data.ccinfo.caption}}</div>
	</div>
	<div style="text-align:center; padding-top:25px;">
		<button type="button" class="btn-bordered-image text-base" (click)="downloadInvoice($event)">
			<div class="image-icon-badge mr-2"><mat-icon svgIcon="download"></mat-icon></div>
			<div style="margin-inline-end:15px">{{'download_invoice' | translate}}</div>
		</button>
	</div>
</div>
<div class="_dialog-actions">
	<button mat-stroked-button class="lg main-continue-btn" type="button" [mat-dialog-close]="true">
		<div class="_inner text-accent justify-content-center">
			<span>{{(data.workMode == 'tabitOrder' ? 'close' : 'back_to_bill') | translate}}</span>
		</div>
	</button>
</div>


